export const getCookie = (key, parse = false) => {
	if (!key) return;
	try {
		const cookie = document?.cookie
			.split("; ")
			.find((row) => row.split("=")[0] === key);
		let cookieValue = cookie ? cookie.split("=")[1] : "";
		if (parse && cookieValue) {
			return JSON.parse(decodeURIComponent(cookieValue));
		}
		return cookieValue;
	} catch (error) {
		console.error(error);
	}
};

export const setCookie = (key, value, numberOfDays) => {
	if (!key) return;
	try {
		const expires = new Date();
		expires.setDate(expires.getDate() + numberOfDays);
		if (window?.document)
			window.document.cookie = `${key}=${value}; expires=${expires.toUTCString()}; path=/`;
	} catch (error) {
		console.error(error);
	}
};

export const removeCookie = (key) => {
	if (!key) return;
	try {
		if (window?.document)
			window.document.cookie = `${key}=; expires=Thu, 01 Jan 1970 00:00:00 GMT; path=/`;
	} catch (error) {
		console.error(error);
	}
};

const decodeCookieValue = (currentCookieValue) => {
	if (currentCookieValue) {
		try {
			const decodedCookieValue = JSON.parse(
				decodeURIComponent(currentCookieValue)
			);
			if (decodedCookieValue) {
				return decodedCookieValue;
			}
		} catch (error) {
			console.error(error);
		}
	}
	return null;
};

export const getCookieValue = (baseCookieValue, cookieNames = []) => {
	for (let index = 0; index < cookieNames.length; index++) {
		const cookieName = cookieNames[index];
		const currentCookieValue = decodeCookieValue(getCookie(cookieName));
		if (currentCookieValue) {
			return currentCookieValue;
		}
	}
	if (baseCookieValue) {
		return decodeCookieValue(baseCookieValue);
	}
	return null;
};

/**
 * Resolves once the given cookie has a non-empty value, polling at a fixed
 * interval until it appears or the timeout elapses. Useful for cookies set
 * asynchronously by third parties (e.g. Adobe's `s_ecid`).
 *
 * @param {string} key Cookie name to wait for.
 * @param {object} [options]
 * @param {number} [options.timeout=5000] Max time to wait, in ms.
 * @param {number} [options.interval=200] Poll interval, in ms.
 * @returns {Promise<string>} The cookie value, or "" if it never appears.
 */
export const waitForCookie = (key, { timeout = 5000, interval = 200 } = {}) => {
	return new Promise((resolve) => {
		if (!key) {
			resolve("");
			return;
		}
		const existing = getCookie(key);
		if (existing) {
			resolve(existing);
			return;
		}
		const startTime = Date.now();
		const timer = setInterval(() => {
			const value = getCookie(key);
			if (value || Date.now() - startTime >= timeout) {
				clearInterval(timer);
				resolve(value || "");
			}
		}, interval);
	});
};

export const getConversationIdCookie = () => {
	return (
		getCookie("Conversation_UUID") ||
		getCookie("convId") ||
		getCookie("PHPSESSID")
	);
};

export const getGeolocationCookieData = (baseCookieValue, cookieNames) => {
	try {
		const geolocationCookieData = getCookieValue(baseCookieValue, cookieNames);
		const cookieData = {};
		if (geolocationCookieData) {
			const {
				region = "",
				country = "",
				metro = "",
				zipCode = "",
			} = geolocationCookieData;
			if (country) {
				cookieData["country"] = country
					.toLowerCase()
					.replace(/[+ ]/g, "_")
					.replace(/-/g, "");
			}
			if (region) {
				cookieData["region"] = region.toLowerCase();
			}
			if (metro) {
				cookieData["city"] = metro.toLowerCase();
			}
			if (zipCode) {
				cookieData["zipCodes"] = zipCode.replace(/-/g, "+").split("+");
			}
		}
		return cookieData;
	} catch (error) {
		console.error(error);
		return {};
	}
};
